var Onboarding = {
  currentStep: null,
  init: function () {
    this.currentStep = 1;
    $('#fields-step-' + this.currentStep).show();
  },
  step: function (next) {
    var stepContainer = $('.step-container');
    $('#fields-step-' + this.currentStep).hide();
    if (next) {
      if (this.currentStep === 3) {
        this.submitAll();
      } else {
        stepContainer.eq(this.currentStep - 1).addClass('completed').removeClass('active');
        this.currentStep++;
        stepContainer.eq(this.currentStep - 1).addClass('active');
      }
    } else {
      if (this.currentStep !== 1) {
        stepContainer.eq(this.currentStep - 1).removeClass('active');
        this.currentStep--;
        stepContainer.eq(this.currentStep - 1).removeClass('completed').addClass('active');
      }
    }
    $('#fields-step-' + this.currentStep).show();
  },
  validate: function () {
    $('#btn-step-forward').prop('disabled', true);
    $('#btn-step-back').prop('disabled', true);
    var formData = new FormData();
    var currentStep = this.currentStep;
    for (var i = 1; i <= this.currentStep; i++) {
      var stepMap = this.gatherStep(i);
      stepMap.forEach(function (value, key, map) {
        if (key === "models" && i !== currentStep) return;
        formData.append(key, value);
      });
    }

    $.ajax({
      type: 'POST',
      url: '/apc/validate/',
      data: formData,
      cache: false,
      contentType: false,
      processData: false
    }).done(function (response) {
      $(".form-control-feedback").remove();
      Onboarding.step(true);
      $('#btn-step-forward').prop('disabled', false);
      $('#btn-step-back').prop('disabled', false);
    }).fail(function (response) {
      //parse JSON errors and display them
      var fieldErrors = $.parseJSON(response.responseJSON).fieldErrors;
      console.log(fieldErrors);
      stepMap.forEach(function (value, key, map) {
        if (fieldErrors.hasOwnProperty(key)) {
          if(key.includes("description")) {
            $('textarea[name="' + key + '"]').parent().addClass("has-error")
              .append("<div class=\"form-control-feedback form-error\">" + fieldErrors[key] + "</div>");
          } else {
            $('input[name="' + key + '"]').parent().addClass("has-error")
              .append("<div class=\"form-control-feedback form-error\">" + fieldErrors[key] + "</div>");
          }
        } else {
          $('input[name="' + key + '"]').parent().removeClass("has-error");
        }
      });
      $("html, body").animate({scrollTop: 0}, "slow");
      $('#btn-step-forward').prop('disabled', false);
      $('#btn-step-back').prop('disabled', false);
    });
  },
  generateTypeaheadSource: function (value, process) {
    return $.get("https://ariregister.rik.ee/autocomplete.py?nimi=" + value, function (data) {
      var dto = [];
      for (var i = 0; i < data.length; i++) {
        dto.push({name: data[i].nimi, regcode: data[i].registrikood});
      }
      return process(dto);
    });
  },
  queryRIKData: function (item) {
    var formData = new FormData();
    formData.append("registryCode", item.regcode);
    $.ajax({
      type: 'POST',
      url: '/apc/partner/create/rik/',
      data: formData,
      cache: false,
      contentType: false,
      processData: false
    }).done(function (response) {
      var json = JSON.parse(response)[0];
      console.log(json);
      $('#registryCode').val(json.ariregistri_kood);
      if(!jQuery.isEmptyObject(json.kmkr_nr)) $('#vatCode').val(json.kmkr_nr);
      $('#legalAddress').val(json.ettevotja_aadress.ads_normaliseeritud_taisaadress);
    }).fail(function (response) {
      console.log(response);
    });
  },
  loadContract: function (name) {
    var formData = new FormData();
    formData.append("categoryName", name);
    $.ajax({
      type: 'POST',
      url: '/apc/partner/contract/',
      data: formData,
      cache: false,
      contentType: false,
      processData: false
    }).done(function (response) {
      $('.form-text-wrapper').html(response);
    }).fail(function (response) {
      console.log(response);
    });
  },
  submitAll: function () {
    $('#btn-step-forward').prop('disabled', true);
    $('#btn-step-back').prop('disabled', true);
    $('#main-create-form').submit();
  },
  showCourierAddress: function () {
    if ($('#delivery-channel-5').is(':checked') || $('#delivery-channel-4').is(':checked'))
      $("#courier-address").removeClass("hidden");
    else
      $("#courier-address").addClass("hidden");
  },
  addEmail: function () {
    var input = $('#add-email-input');
    var appendString = '<div>' +
      '<input type="hidden" class="added-email" name="userEmails[]" value="' + input.val() + '">' +
      input.val() +
      '<button type="button" class="btn btn-sm btn-danger remove-email float-right">Kustuta</button>' +
      '</div>';
    $("#email-list").append(appendString);
    input.val("");
    $('.remove-email').on('click', Onboarding.deleteEmail);
  },
  deleteEmail: function (e) {
    var target = $(e.currentTarget).parent();
    console.log(target);
    target.remove();
  },
  successHandlerSmartID: function (dto) {
    $('input[name="ssn"]').addClass("is-valid");
    $('#randomUUID').val(dto.content);
    Onboarding.validate();
  },
  gatherStep: function (number) {
    if (number === 1)
      return this.gatherStep1();
    if (number === 2)
      return this.gatherStep2();
    if (number === 3)
      return this.gatherStep3();

    return null;
  },
  gatherStep1: function () {
    var valueMap = new Map();
    var stepDiv = $('#fields-step-1');

    valueMap.set("repFirstName", stepDiv.find('input[name="repFirstName"]').val());
    valueMap.set("repLastName", stepDiv.find('input[name="repLastName"]').val());
    valueMap.set("ssn", stepDiv.find('input[name="ssn"]').val());
    valueMap.set("randomUUID", stepDiv.find('input[name="randomUUID"]').val());
    valueMap.set("legalName", stepDiv.find('input[name="legalName"]').val());
    valueMap.set("legalAddress", stepDiv.find('input[name="legalAddress"]').val());
    valueMap.set("registryCode", stepDiv.find('input[name="registryCode"]').val());
    valueMap.set("vatCode", stepDiv.find('input[name="vatCode"]').val());
    valueMap.set("iban", stepDiv.find('input[name="iban"]').val());
    valueMap.set("category", stepDiv.find('select[name="category"]').val());
    valueMap.set("acceptTerms", stepDiv.find('input[name="acceptTerms"]').is(":checked"));

    valueMap.set("models", "models.BusinessData,models.AcceptTerms,models.GuideCategory");

    return valueMap;
  },
  gatherStep2: function () {
    var valueMap = new Map();
    var stepDiv = $('#fields-step-2');

    valueMap.set("name", stepDiv.find('input[name="name"]').val());
    //valueMap.set("address", stepDiv.find('input[name="address"]').val());
    valueMap.set("description-et", stepDiv.find('textarea[name="description-et"]').val());
    valueMap.set("description-en", stepDiv.find('textarea[name="description-en"]').val());
    valueMap.set("description-ru", stepDiv.find('textarea[name="description-ru"]').val());
    valueMap.set("description-fi", stepDiv.find('textarea[name="description-fi"]').val());
    valueMap.set("phone", stepDiv.find('input[name="phone"]').val());
    valueMap.set("email", stepDiv.find('input[name="email"]').val());
    var emails = "";
    stepDiv.find('input[name="userEmails[]"]').each(function () {
      emails += $(this).val() + ","
    });
    if (emails === ""){
      valueMap.set("userEmails", "");
    }else{
      valueMap.set("userEmails", emails.substring(0, emails.length - 1));
    }
    valueMap.set("add-email-input", "");//hack for error message to work

    valueMap.set("models", "models.Partner,ignored.UserEmails");

    return valueMap;
  },
  gatherStep3: function () {
    var valueMap = new Map();
    var stepDiv = $('#fields-step-3');

    stepDiv.find('input[name="deliveryChannel"]').each(function () {
      valueMap.set("deliveryChannel", $(this).val());
    });
    valueMap.set("preferredDeliveryChannel", stepDiv.find('select[name="preferredDeliveryChannel"]').val());
    valueMap.set("delivery-terminal-smartpost", stepDiv.find('select[name="delivery-terminal-smartpost"]').val());
    valueMap.set("returnAddress", stepDiv.find('input[name="returnAddress"]').val());
    valueMap.set("returnNumber", stepDiv.find('input[name="returnNumber"]').val());
    valueMap.set("returnAddressCourier", stepDiv.find('input[name="returnAddressCourier"]').val());

    valueMap.set("models", "models.Partner,ignored.TestEShop");

    return valueMap;
  }
}